import PriceService from '@/utils/PriceService.js';
import { mapGetters } from 'vuex';

// This mixin is strictly for use when editing a single wardrobe (Creator context)
// For cart summaries, use the 'cart/refreshAllCartPrices' action.

export default {
  data() {
    return {
      isFetchingPrice: false,
      fetchPriceError: null,
    };
  },
  computed: {
    ...mapGetters('creator', [
      'wardrobe',
      'doors',
      'inventory'
    ])
  },
  methods: {
    async fetchPrice (localState = {}, shouldSendDoors = true, shouldSendInventory = true) {
      this.isFetchingPrice = true;
      this.fetchPriceError = null;

      const baseState = {
        wardrobe: this.wardrobe,
        doors: this.doors,
        inventory: this.inventory
      };

      const payload = PriceService.buildPayload(
        baseState,
        localState,
        shouldSendDoors,
        shouldSendInventory
      );

      try {
        const priceData = await PriceService.fetchPrice(payload);
        this.$store.commit('creator/setPrice', priceData);
        this.fetchPriceError = false;
      } catch (e) {
        console.error('Fetch price mixin error:', e);
        this.$store.commit('creator/resetPrice');
        this.fetchPriceError = true;
      } finally {
        this.isFetchingPrice = false;
      }
    }
  }
};
